import React from 'react';
import { BookingsTableData, BookingsApiModel, NON_EDITABLE_BOOKING_STATUSES } from './helpers';
import { CellProps } from 'react-table';
import TextInputCell from '../../../ui/Table/Cells/TextInputCell';

type FinancialReferenceCellProps<T extends BookingsTableData> = CellProps<T> & {
    updateBooking?: (id: number, data: BookingsApiModel) => Promise<void>;
};

const FinancialReferenceCell = <T extends BookingsTableData>({
    updateBooking,
    ...props
}: FinancialReferenceCellProps<T>) => {
    const { date_approved, status, id } = props.row.original;
    const disabled = Boolean(date_approved) || NON_EDITABLE_BOOKING_STATUSES.includes(status);
    return (
        <TextInputCell
            {...props}
            disabled={disabled}
            onSubmit={async (value) => {
                if (typeof updateBooking === 'function' && value !== props.value) {
                    await updateBooking(id, { finance_reference: value });
                }
            }}
        />
    );
};

export default FinancialReferenceCell;
